import React from "react"
import { useTranslation } from "react-i18next"
import { Container, Row, Card, CardHeader, Table, Badge } from "reactstrap"
import Header from "../../components/Headers/Header"
import { getTipReport } from "../../apollo/server"
import { useQuery, gql } from "@apollo/client"

interface RiderRow {
  riderId: string | null
  riderName: string
  orders: number
  totalTip: number
}
interface MonthRow {
  month: string
  orders: number
  totalTip: number
  riders: RiderRow[]
}

const yen = (n: number) => `¥${Math.round(n).toLocaleString()}`

// 会計向け: 配達員チップの月次集計。月ごとに合計と配達員別の内訳を表示する。
const TipReport: React.FC = () => {
  const { t } = useTranslation()
  const { loading, error, data } = useQuery(gql`${getTipReport}`, { fetchPolicy: "cache-and-network" })

  const months: MonthRow[] = (data && data.tipReport) || []

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row className="mt-3">
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">{t("TipReportTitle")}</h3>
                <small className="text-muted">{t("TipEnabledHint")}</small>
              </CardHeader>

              {error && <p className="px-4">{`${t("Error")}! ${error.message}`}</p>}
              {loading && !data && <p className="px-4">{t("Loading")}</p>}
              {!loading && months.length === 0 && <p className="px-4 text-muted">{t("TipReportNoData")}</p>}

              {months.map(m => (
                <div key={m.month} className="px-4 pb-4">
                  <h4 className="mt-3 mb-2">
                    {m.month}{" "}
                    <Badge color="primary" pill>
                      {t("TipReportTotal")}: {yen(m.totalTip)}
                    </Badge>{" "}
                    <Badge color="secondary" pill>
                      {t("TipReportOrders")}: {m.orders}
                    </Badge>
                  </h4>
                  <Table className="align-items-center table-flush" responsive bordered>
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">{t("TipReportRider")}</th>
                        <th scope="col">{t("TipReportOrders")}</th>
                        <th scope="col">{t("TipReportTotal")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {m.riders
                        .slice()
                        .sort((a, b) => b.totalTip - a.totalTip)
                        .map((r, i) => (
                          <tr key={`${m.month}-${r.riderId || "none"}-${i}`}>
                            <td>{r.riderName}</td>
                            <td>{r.orders}</td>
                            <td>{yen(r.totalTip)}</td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </div>
              ))}
            </Card>
          </div>
        </Row>
      </Container>
    </>
  )
}

export default TipReport
